import React from 'react';
import { Box, Typography, Paper, Skeleton } from '@mui/material';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
} from 'recharts';

const AverageMarginByMonthChart = ({ data = [], loading }) => {
  return (
    <Paper elevation={3} sx={{ p: 2 }}>
      <Typography variant="subtitle1" gutterBottom>
        Evolución del margen promedio mensual
      </Typography>
      <Box sx={{ width: '100%', height: 320 }}>
        {loading ? (
          <Skeleton variant="rectangular" width="100%" height={320} />
        ) : data.length > 0 ? (
          <ResponsiveContainer>
            <LineChart data={data} margin={{ top: 10, right: 20, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="month" />
              <YAxis unit="%" />
              <Tooltip formatter={(value) => `${value}%`} />
              <Line
                type="monotone"
                dataKey="margin"
                stroke="#42a5f5"
                strokeWidth={3}
                dot={{ r: 4 }}
                name="Margen promedio"
              />
            </LineChart>
          </ResponsiveContainer>
        ) : (
          <Box
            sx={{
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Typography variant="body2" color="textSecondary">
              No hay datos disponibles.
            </Typography>
          </Box>
        )}
      </Box>
    </Paper>
  );
};

export default AverageMarginByMonthChart;
